function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.style.setProperty('--screen-height', `${window.innerHeight}px`);
})

async function subscribeToNewsletter(klaviyoId, listId, email) {
  if (!klaviyoId || !listId || !email) return false;

  const data = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      revision: '2023-07-15',
    },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId,
            },
          },
        },
      },
    })
  };

  try {
    const link = `https://a.klaviyo.com/client/subscriptions/?company_id=${klaviyoId}`;
    const response = await fetch(link, data);
    return response;
  } catch (error) {
    console.error(error.message);
  }
}

function reportInputValidity(input, errorBlock) {
  if (!input || !errorBlock) return false;

  const type = input.type;
  const value = input.value.trim();
  let isValid = true;
  let errorType = "empty";

  isValid = value === "" ? false : true;

  switch (type) {
    case "email":
      if (value !== "" && !input.checkValidity()) {        
        isValid = false;
        errorType = "email"
      }
      break;
  }

  if (isValid) {
    input.removeAttribute("aria-invalid");
    errorBlock.innerText = "";
  } else {
    input.setAttribute("aria-invalid", true);
    errorBlock.innerText = window.errorStrings[errorType];
  }

  return isValid;
}

window.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector("[js-localization]")) {
    const localizationForms = document.querySelectorAll("[js-localization]");
    
    localizationForms.forEach(localizationForm => {
      const formToggle = localizationForm.querySelector("[js-localization-toggle]");
      
      formToggle.addEventListener("click", () => {    
        localizationForm.classList.toggle("open");
      })
  
      localizationForm.addEventListener("change", (e) => {
        localizationForm.querySelector("[name='country_code']").value = e.target.value;
        localizationForm.classList.remove("open");
        localizationForm.submit();
      })
    })
  }
})


// --- SECTIONS --- //

class Header {
  constructor(root) {
    this.root = root;
    this.mobileMenu = this.root.querySelector("#MobileMenu");
    this.headerSearch = this.root.querySelector("#HeaderSearch");
    this.headerPredictiveResults = this.root.querySelector("#HeaderPredictiveResults");
    this.headerSearchInput = this.headerSearch.querySelector("input");
    this.allAnnouncementsHeight = 0;
    this.isLoading = false;

    this.calcHeader();
    
    this.root.addEventListener('click', this.onClick.bind(this));
    
    window.addEventListener('scroll', () => {
      this.root.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);

      this.updateMenuTop();
    });
    
    this.updateMenuTop();

    if (this.headerSearchInput) {
      this.headerSearchInput.addEventListener('input', debounce((e) => {
        this.onPredictiveChange(e.target.value);
      }, 500).bind(this));
    }
  }

  updateMenuTop() {
    const headerPosition = this.root.getBoundingClientRect();
    const menuPostionTop = headerPosition.top + headerPosition.height;
    document.documentElement.style.setProperty('--header-menu-top', `${menuPostionTop}px`);
  }

  onPredictiveChange(query) {
    if (this.isLoading) return;

    if (query === "") {
      this.headerPredictiveResults.innerHTML = "";
      return;
    }

    this.isLoading = !this.isLoading;

    const searchUrl = `/search/suggest?q=${encodeURIComponent(query.trim())}&resources[type]=product&section_id=predictive-results`;

    fetch(searchUrl)
    .then(response => {
      if (!response.ok) {
        this.headerPredictiveResults.innerHTML = "";
        return;
      }

      return response.text();
    })
    .then(response => {
      const responseMarkup = new DOMParser().parseFromString(response, 'text/html');
      this.headerPredictiveResults.innerHTML = responseMarkup.querySelector("#shopify-section-predictive-results").innerHTML;
    })
    .catch(error => console.error(error))
    .finally(() => this.isLoading = !this.isLoading)
  }
  
  calcHeader() {
		const headerObserver = new ResizeObserver(() => {
			this.headerHeight = this.root.getBoundingClientRect().height;
			document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);

      const announcements = document.querySelectorAll(".announcement");
      this.allAnnouncementsHeight = Math.max(Array.from(announcements).reduce((sum, el) => {
        return sum + el.offsetHeight;
      }, 0), 1);
      
      this.root.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);
		});

		headerObserver.observe(this.root);
	}

  onClick(event) {
    if (event.target.hasAttribute("data-action")) {
      switch (event.target.dataset.action) {
        case "menu-toggle":
          this.mobileMenu.classList.toggle("open");
          if (document.documentElement.style.overflow === "hidden") {
            document.documentElement.style.overflow = null;
          } else {
            document.documentElement.style.overflow = "hidden";
          }
          break;
        case "search-open":
          this.headerSearch.classList.add('open');
          document.documentElement.style.overflow = "hidden";
          break;
        case "search-close":
          this.headerSearch.classList.remove('open');
          document.documentElement.style.overflow = null;
          break;
        case "megamenu-open":
          event.target.classList.add('open');
          break;
        case "megamenu-close":
          event.target.closest("li").querySelector("[data-action]").classList.remove('open');
          break;
        case "reset-search":
          this.headerSearchInput.value = "";
          this.onPredictiveChange("");
          break;
        case "select-query":
          this.headerSearchInput.value = event.target.dataset.query;
          this.onPredictiveChange(event.target.dataset.query);
          break;
      }
    }
  }
}

if (document.querySelector("header")) {
  new Header(document.querySelector("header"))
}

class FeaturedProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.type == "recommendations") {
      this.setRecommendationProducts();
    }
  }

  setRecommendationProducts() {
    const recommendationLink = window.Shopify.routes.root + `recommendations/products?limit=4&product_id=${this.dataset.product}&intent=${this.dataset.recommendations}&section_id=${this.dataset.section}`;
      fetch(recommendationLink)
      .then(response => response.text())
      .then(response => {
        const html = new DOMParser().parseFromString(response, "text/html");

        if (html.querySelector("featured-products[data-empty]")) {
          this.style.display = "none";
          return;
        }
        
        const grid = this.querySelector('[id^="Slider-"]');
        grid.innerHTML = html.querySelector('[id^="Slider-"]').innerHTML;

        this.querySelector("slider-component").update();
      })
      .catch(error => console.error(error))
  }
}

if (document.querySelector("featured-products")) {
  customElements.define("featured-products", FeaturedProduct);
}

class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.productVariants = JSON.parse(this.querySelector("[data-variants-data]").textContent);
    this.cart = document.querySelector("cart-drawer");
    this.gallery = this.querySelector('[id^="ProductGallery-"]');
    this.navGallery = this.querySelector('[id^="ProductGalleryNav-"]');
    this.stickyBar = this.querySelector('[id^="ProductSticky-"]');
    this.productSubmit = this.querySelector('[id^="ProductSubmit-"]');
    this.productSubmitPopup = this.querySelector('[id^="ProductSubmitPopup-"]');
    this.currentSlide = 1;

    this.querySelector('[id^="ProductOptions-"]')?.addEventListener("change", this.onVariantChange.bind(this));
    this.querySelector('[id^="ProductForm-"]')?.addEventListener("submit", this.onFormSubmit.bind(this));
    this.initClickListeners();

    if (this.gallery) {
      this.initGallery();
    }

    if (this.stickyBar && this.productSubmit) { 
      const needToShow = !this.isInViewport(this.productSubmit);
      this.stickyBar.classList.toggle("show", needToShow);

      window.addEventListener("scroll", () => {
        this.stickyBar.classList.toggle("show", (!this.isInViewport(this.productSubmit)));
      })
    }
  }

  onVariantChange() {
    if (this.isLoading) return;

    this.toggleLoading();

    const searchParams = new URLSearchParams();
    let selectedValuesLabel = '';

    [1, 2, 3].forEach(option => {
      if (this.querySelector(`[data-option="${option}"]`)) {
        if (this.querySelector(`[data-option="${option}"] input:checked`)) {
          selectedValuesLabel += ' / ' + this.querySelector(`[data-option="${option}"] input:checked`).value;
        } else {
          selectedValuesLabel += ' / ' + this.querySelector(`[data-option="${option}"] input`).value;
        }
      }
    });

    this.productVariants.forEach(variant => {
      if (variant.title === selectedValuesLabel.slice(3)) {
        if (this.querySelector("input[name='id']")) {
          this.querySelector("input[name='id']").value = variant.id;
        }
        searchParams.set('variant', variant.id);
      }
    })

    const newProductUrl = window.location.origin + window.location.pathname + `?${searchParams.toString()}`;
    window.history.replaceState({}, '', newProductUrl);

    fetch(newProductUrl)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");

      this.renderContent(html);
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading())
  }

  onFormSubmit(event = false, skipPopup = false) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    if (this.productSubmitPopup && !skipPopup) {
      this.productSubmitPopup.classList.add("open");
      return;
    }

    const sections = [];
    if (this.cart) sections.push("cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(this.querySelector("[name='id']").value),
          quantity: parseInt(this.querySelector("[name='quantity']").value)
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    if (this.querySelector('[name="additional"]')) {
      cartData.items.push({
        id: parseInt(this.querySelector("[name='additional']").value),
        quantity: 1
      })
    }

    this.addToCart(cartData);
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.toggleLoading();
        
        if (this.cart) {
          this.cart.renderContent(response.sections);
          this.cart.open();
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  renderContent(html) {
    const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
    const selectors = ['[id^="ProductPrice-"]', '[id^="ProductOptions-"]', '[id^="ProductAvailability-"]', '[id^="ProductSubmit-"]'];

    selectors.forEach(selector => {
      const currentSelectors = this.querySelectorAll(selector);
      const newSelectors = section.querySelectorAll(selector);

      if (currentSelectors.length > 0 && currentSelectors.length == newSelectors.length) {
        currentSelectors.forEach((currentSelector, i) => {
          currentSelector.innerHTML = newSelectors[i].innerHTML;
        })
      }
    });

    if (this.querySelector('[id^="ProductSubmit-"]')) {
      const currentButton = this.querySelector('[id^="ProductSubmit-"]');
      const newButton = section.querySelector('[id^="ProductSubmit-"]');
      currentButton.toggleAttribute("disabled", newButton.disabled);
    }
  }

  initClickListeners() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "prev-slide":
            if (this.currentSlide > 1) {
              this.currentSlide -= 1;
              this.scrollToSlide(this.currentSlide, this.gallery);
            }
            break;
          case "next-slide":
            if (this.currentSlide < this.maxLength) {
              this.currentSlide += 1;
              this.scrollToSlide(this.currentSlide, this.gallery);
            }
            break;
          case "select-slide":
            this.currentSlide = parseInt(e.target.dataset.index);
            this.scrollToSlide(this.currentSlide, this.gallery);
            break;
          case "disclosure-open":
            const popup = this.querySelector(`[data-disclosure-popup="${e.target.dataset.disclosure}"]`)
            popup?.classList.add("open");
            break;
          case "disclosure-close":
            e.target.closest("[data-disclosure-popup]").classList.remove("open");
            break;
          case "close-compare":
            this.querySelector('[id^="ProductCompare-"]').classList.remove("open");
            break;
          case "open-compare":
            this.querySelector('[id^="ProductCompare-"]').classList.add("open");
            break;
          case "add-compare":
            const compareItems = JSON.parse(e.target.getAttribute("data-items"));

            const cartData = {
              items: compareItems,
              sections: [],
              sections_url: window.location.pathname
            };

            if (this.cart) cartData.sections.push("cart-drawer");

            this.addToCart(cartData);
            this.querySelector('[id^="ProductCompare-"]').classList.remove("open");
            break;
          case "scroll-to-reviews":
            e.preventDefault();
            const reviewsSection = document.querySelector(`#${e.target.href.split("#")[1]}`);
            

            if (reviewsSection) {
              const headerHeightStyle = getComputedStyle(document.documentElement).getPropertyValue('--header-height')
              const headerHeight = parseInt(headerHeightStyle, 10) || 0;

              const reviewsPosition = reviewsSection.getBoundingClientRect().top + window.scrollY;
              const offsetPosition = reviewsPosition - headerHeight;

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
            break;
          case "sticky-add": 
            this.onFormSubmit();
            break;
          case "add-upgrade": 
            this.productSubmitPopup.classList.remove("open");
            this.querySelector("[name='id']").value = e.target.dataset.variant;
            this.onFormSubmit(false, true);
            break;
          case "skip-upgrade": 
            this.productSubmitPopup.classList.remove("open");
            this.onFormSubmit(false, true);
            break;
        }
      }
    })
  }

  initGallery() {
    this.updateGallery();
    window.addEventListener('resize', this.updateGallery.bind(this));
    this.gallery.addEventListener('scroll', this.updateGallery.bind(this));
  }

  updateGallery() {
    const items = this.gallery.querySelectorAll('[data-index]');
    const scrollLeft = this.gallery.scrollLeft;
    const scrollWidth = this.gallery.scrollWidth;
    const clientWidth = this.gallery.clientWidth;
    const blockWidth = items[0]?.offsetWidth ?? 0;
    const hasScroll = scrollWidth > clientWidth;

    const scrollbar = this.querySelector("[slider-scrollbar]");
    const scrollbarThumb = this.querySelector("[slider-scrollbar] span");
    const thumbWidth = (clientWidth / scrollWidth) * 100;
    const thumbPosition = (scrollLeft / (scrollWidth - clientWidth)) * 100;

    const prevButton = this.querySelector('[data-action="prev-slide"]');
    const nextButton = this.querySelector('[data-action="next-slide"]');

    const counter = this.querySelector("[slider-counter]");
    
    this.maxLength = items.length - (Math.floor(clientWidth / blockWidth) - 1);
    this.currentSlide = Math.round(scrollLeft / blockWidth) + 1;    

    if (scrollbarThumb) {
      scrollbarThumb.style.left = `${thumbPosition}%`;
      scrollbarThumb.style.width = `${thumbWidth}%`;
      scrollbarThumb.style.transform = `translateX(-${thumbPosition}%)`;
      scrollbar.classList.toggle("hidden", !hasScroll);
    }

    if (counter) {
      counter.innerText = `${this.currentSlide} / ${this.maxLength}`;
    }

    prevButton.toggleAttribute("disabled", this.currentSlide == 1);
    nextButton.toggleAttribute("disabled", this.currentSlide == this.maxLength);

    prevButton.classList.toggle("hidden", !hasScroll);
    nextButton.classList.toggle("hidden", !hasScroll);

    if (this.navGallery) {
      const navGallerySlides = this.navGallery.querySelectorAll("[data-index]");

      navGallerySlides.forEach((navGallerySlide, i) => {
        const index = ++i;        
        navGallerySlide.classList.toggle("active", index === this.currentSlide);
      });
    }
  }

  scrollToSlide(index, slider) {    
    if (!slider) return;

    slider.scrollTo({
      left: slider.querySelector(`[data-index="${index}"]`).offsetLeft,
      behavior: 'smooth'
    });
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }


  isInViewport(element) {
    const rect = element.getBoundingClientRect();

    let isInViewport = (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );

    if (rect.top > 0) isInViewport = true;
    
    return isInViewport;
  };
}

if (document.querySelector("main-product")) {
  customElements.define("main-product", MainProduct);
}

class MainCollection extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.productsGrid = this.querySelector('[id^="CollectionGrid-"]');
    this.sortSelect = this.querySelector('[id^="CollectionSort-"]')

    if (this.sortSelect) {
      this.initChangeEvents();
    }
  }

  filtersUpdate() {
    this.toggleLoading();
    
    let newProductUrl = "";

    if (!newProductUrl) {
      const searchParams = new URLSearchParams();
      searchParams.append("sort_by", this.sortSelect.value);
      
      newProductUrl = window.location.pathname + `?${searchParams.toString()}`;
    }
    
    window.history.replaceState({}, '', newProductUrl);

    fetch(newProductUrl)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");
      const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
      const selectors = ['[id^="CollectionGrid-"]', '[data-pagination]'];

      selectors.forEach(selector => {
        if (this.querySelector(selector) && section.querySelector(selector)) {
          this.querySelectorAll(selector).forEach((selectorElement, i) => {
            selectorElement.innerHTML = section.querySelectorAll(selector)[i].innerHTML;
          })
        }
      })
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading())
  }

  initChangeEvents() {
    this.sortSelect.addEventListener("change", () => {
      if (!this.isLoading) {
        this.filtersUpdate();
      }
    })
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("main-collection")) {
  customElements.define("main-collection", MainCollection);
}

class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.productsGrid = this.querySelector('[id^="SearchGrid-"]');
    this.sortSelect = this.querySelector('[id^="SearchSort-"]');
    this.searchInput = this.querySelector('[id^="SearchInput-"]');
    this.resetButton = this.querySelector('[data-action="reset-search"]');

    if (this.sortSelect) {
      this.sortSelect.addEventListener("change", () => {
        if (!this.isLoading) {
          this.resultsUpdate();
        }
      })
    }

    if (this.searchInput) {
      this.searchInput.addEventListener('input', debounce(() => {
        this.resultsUpdate();
      }, 500).bind(this));
    }

    if (this.resetButton) {
      this.resetButton.addEventListener("click", () => {
        this.searchInput.value = "";
        this.resultsUpdate();
      })
    }
  }

  resultsUpdate() {
    this.toggleLoading();
    
    let newProductUrl = "";

    if (!newProductUrl) {
      const searchParams = new URLSearchParams();
      searchParams.append("q", this.searchInput.value);
      searchParams.append("sort_by", this.sortSelect.value);
      
      newProductUrl = window.location.pathname + `?${searchParams.toString()}`;
    }
    
    window.history.replaceState({}, '', newProductUrl);

    fetch(newProductUrl)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");
      const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
      const selectors = ['[id^="SearchGrid-"]', '[data-count]', '[data-pagination]', '[data-empty]'];

      this.setAttribute("data-empty", section.getAttribute("data-empty"));

      selectors.forEach(selector => {
        if (this.querySelector(selector) && section.querySelector(selector)) {
          this.querySelectorAll(selector).forEach((selectorElement, i) => {
            selectorElement.innerHTML = section.querySelectorAll(selector)[i].innerHTML;
          })
        }
      })
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading())
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("main-search")) {
  customElements.define("main-search", MainSearch);
}

// --- COMPONENTS --- //

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentSlide = 1;
    this.slider = this.querySelector('[id^="Slider-"]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.scrollbar = this.querySelector("[slider-scrollbar]");
    this.scrollbarThumb = this.querySelector("[slider-scrollbar] span");

    if (!this.slider || !this.nextButton) return;

    this.update();
    window.addEventListener('resize', this.update.bind(this));
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  disconnectedCallback() {
    this.slider.removeEventListener('scroll', this.update);
    this.prevButton.removeEventListener('click', this.onButtonClick);
    this.nextButton.removeEventListener('click', this.onButtonClick);
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.currentTarget.name === 'previous' && this.currentSlide > 1) {
      this.currentSlide -= 1;
    } else if (event.currentTarget.name === 'next' && this.currentSlide < this.maxLength) {
      this.currentSlide += 1;
    }
    this.scrollToSlide(this.currentSlide);
  }

  scrollToSlide(index) {
    this.slider.scrollTo({
      left: this.querySelector(`[id^="Slide-"]:nth-child(${index})`).offsetLeft,
      behavior: 'smooth'
    });
  }

  update() {
    const items = this.querySelectorAll('[id^="Slide-"]');
    const scrollLeft = this.slider.scrollLeft;
    const scrollWidth = this.slider.scrollWidth;
    const clientWidth = this.slider.clientWidth;
    const blockWidth = items[0]?.offsetWidth ?? 0;
    const gap = window.innerWidth < 750 ? 16 : 24;
    const hasScroll = this.slider.scrollWidth > clientWidth;
    const thumbPosition = (scrollLeft / (scrollWidth - clientWidth)) * 100;
    const thumbWidth = (clientWidth / scrollWidth) * 100;
      
    this.maxLength = items.length - (Math.floor(clientWidth / blockWidth) - 1);
    this.currentSlide = Math.round(scrollLeft / (blockWidth + gap)) + 1;

    if (this.scrollbarThumb) {
      this.scrollbarThumb.style.left = `${thumbPosition}%`;
      this.scrollbarThumb.style.width = `${thumbWidth}%`;
      this.scrollbarThumb.style.transform = `translateX(-${thumbPosition}%)`;
      this.scrollbar.classList.toggle("hidden", !hasScroll);
    }

    this.prevButton.toggleAttribute("disabled", this.currentSlide == 1);
    this.nextButton.toggleAttribute("disabled", this.currentSlide == this.maxLength);

    this.prevButton.classList.toggle("hidden", !hasScroll);
    this.nextButton.classList.toggle("hidden", !hasScroll);
  }
}

if (document.querySelector("slider-component")) {
  customElements.define("slider-component", SliderComponent);
}

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-drawer");
    this.quickAddButton = this.querySelector('[name="quick-add"]');
    this.isLoading = false;
  }

  connectedCallback() {
    if (this.quickAddButton) {
      this.quickAddButton.addEventListener("click", this.addToCart.bind(this));
    }
  }

  addToCart(event) {
    event.preventDefault();

    if (this.isLoading) return;

    this.toggleLoading();

    const sections = [];
    if (this.cart) sections.push("cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(this.quickAddButton.dataset.variant),
          quantity: 1
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        throw new Error(response.description);
      } else {
        if (this.cart) {
          this.cart.renderContent(response.sections);
          this.cart.open();
        }
      }
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading());
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("product-card")) {
  customElements.define("product-card", ProductCard);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.timer = this.querySelector("#CartDrawer-Timmer") ?? null;

    this.initClickEvents();
  }

  connectedCallback() {
    this.initClickEvents();

    document.addEventListener("click", (e) => {
      if (e.target.hasAttribute("cart-drawer-toggle")) {
        this.open();
      }
    })

    if (this.hasAttribute("data-gift-js")) {
      this.updateGift();
    }

    if (this.timer) {
      this.initTimer();
    }
  }

  initTimer() {
    let timerTime = 600;

    this.timerInterval = setInterval(() => {
      let minutes = Math.floor(timerTime / 60);
      let seconds = timerTime % 60;
  
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;
  
      this.timer.textContent = `${minutes}:${seconds}`;
  
      if (timerTime === 0) {
        clearInterval(this.timerInterval);
      }
  
      timerTime--;
    }, 1000);
  }

  updateQuantity(item, quantity, itemEl = false) {
    this.toggleLoading(itemEl);
    
    const data = {
      line: item,
      quantity: quantity,
      sections: ["cart-drawer"],
      sections_url: window.location.pathname
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(response => {
      if (response.sections) {
        this.renderContent(response.sections);
      } else {
        throw new Error(response.description);
      }
    })
    .catch((error) => {
      const itemEl = this.querySelector(`[data-item="${item}"]`);
      const messageBlock = itemEl.querySelector("[item-notification]");

      console.error('Error:', error);

      messageBlock.innerText = error.message;
      setTimeout(() => {messageBlock.innerText = ""}, 5000);
    })
    .finally(() => {this.toggleLoading(itemEl)});
  }

  renderContent(sections) {
    if (!sections['cart-drawer']) return;

    const html = new DOMParser().parseFromString(sections['cart-drawer'], "text/html");
    const newCartDrawer = html.querySelector("cart-drawer");
    
    this.querySelector("[js-content-items]").innerHTML = newCartDrawer.querySelector("[js-content-items]").innerHTML;
    this.querySelector("[js-content-footer]").innerHTML = newCartDrawer.querySelector("[js-content-footer]").innerHTML;
    this.setAttribute("data-count", newCartDrawer.dataset.count);
    this.querySelector("[cart-count]").textContent = `(${newCartDrawer.dataset.count})`;

    if (this.querySelector('[data-progress="shipping"]')) {
      this.querySelector('[data-progress="shipping"]').style.width = newCartDrawer.querySelector('[data-progress="shipping"]').style.width;
    }

    if (this.querySelector('[data-progress="gift"]')) {
      this.querySelector('[data-progress="gift"]').style.width = newCartDrawer.querySelector('[data-progress="gift"]').style.width;
    }

    if (this.querySelector('.cart-drawer__achivements-labels')) {
      this.querySelector('.cart-drawer__achivements-labels').innerHTML = newCartDrawer.querySelector('.cart-drawer__achivements-labels').innerHTML;
    }

    if (this.hasAttribute("data-gift-js")) {
      this.setAttribute("data-gift-js", newCartDrawer.getAttribute("data-gift-js"));
      this.updateGift();
    }

    document.querySelectorAll("[cart-item-count]").forEach(countEl => countEl.innerText = newCartDrawer.dataset.count);
  }

  addItemToCart(item, itemEl = false) {
    this.toggleLoading(itemEl);

    const sections = ["cart-drawer"];

    const cartData = {
      items: [
        {
          id: parseInt(item),
          quantity: 1
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        throw new Error(response.description);
      } else {
        this.renderContent(response.sections);
      }
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading(itemEl));
  }

  updateGift() {
    const giftProduct = this.getAttribute("data-gift");
    const isGiftAddedToCart = this.querySelector(`[data-variant="${giftProduct}"]`)
    const needToAdd = this.getAttribute("data-gift-js") === "true";
    const addedGiftQuantityEl = isGiftAddedToCart?.querySelector("[name='quantity']").value ?? 0;
    const addedGiftQuantity = parseInt(addedGiftQuantityEl);

    if (needToAdd && !isGiftAddedToCart) {
      this.addItemToCart(giftProduct);
    } else if (!needToAdd && isGiftAddedToCart) {
      this.updateQuantity(parseInt(isGiftAddedToCart.dataset.item), 0, isGiftAddedToCart);
    } else if (isGiftAddedToCart && addedGiftQuantity > 1) {
      this.updateQuantity(parseInt(isGiftAddedToCart.dataset.item), 1, isGiftAddedToCart);
    }
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      e.preventDefault();

      const item = e.target.closest("[data-item]");
      const itemQuantityInput = item?.querySelector('[name="quantity"]') ?? false;
      const itemQuantity = parseInt(itemQuantityInput?.value) ?? false;

      switch (e.target.dataset.action) {
        case "close":
          this.close();
          break;
        case "remove-item":
          if (!this.isLoading) {
            this.updateQuantity(parseInt(item.dataset.item), 0);
          }
          break;
        case "decrease-quantity":          
          if (itemQuantity > 1) {
            if (!this.isLoading) {
              this.updateQuantity(parseInt(item.dataset.item), parseInt(itemQuantity - 1), item);
            }
          }
          break;
        case "increase-quantity":
          if (itemQuantity < 199) {
            if (!this.isLoading) {
              this.updateQuantity(parseInt(item.dataset.item), parseInt(itemQuantity + 1), item);
            }
          }
          break;
        case "add-upsell":
          if (!this.isLoading) {
            this.addItemToCart(e.target.dataset.value, e.target);
          }
          break;
        case "to-checkout":
          window.location.pathname = "/checkout";
          break;
      }
    })
  }

  toggleLoading(itemEl) {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading-item", this.isLoading);

    if (itemEl) {
      itemEl.classList.toggle("loading", this.isLoading);
    }
  }

  open() {
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }
}

if (document.querySelector("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

class ProductLightbox extends HTMLElement {
  constructor() {
    super();
    this.gallery = this.querySelector('[id^="ProductLightboxGallery-"]');
    this.navGallery = this.querySelector('[id^="ProductLightboxNav-"]');
    this.counter = this.querySelector("[lightbox-counter]");
    this.prevButton = this.querySelector('[data-action="prev-lightbox-slide"]');
    this.nextButton = this.querySelector('[data-action="next-lightbox-slide"]');
    this.currentSlide = 1;

    if (this.gallery) {
      this.init();
    }
  }


  connectedCallback() {
    console.log("CHECKL");
    this.initClickListeners();

    document.addEventListener("click", (e) => {
      if (e.target.hasAttribute("js-open-lightbox")) {
        this.classList.add("open");
        this.scrollToSlide(e.target.getAttribute("js-open-lightbox"));
      }
    })
  }

  initClickListeners() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "prev-lightbox-slide":
            if (this.currentSlide > 1) {
              this.currentSlide -= 1;
              this.scrollToSlide(this.currentSlide);
            }
            break;
          case "next-lightbox-slide":
            if (this.currentSlide < this.maxLength) {
              this.currentSlide += 1;
              this.scrollToSlide(this.currentSlide);
            }
            break;
          case "select-lightbox-slide":
            this.currentSlide = parseInt(e.target.dataset.index);
            this.scrollToSlide(this.currentSlide, this.gallery);
            break;
          case "close":
            this.classList.remove("open");
            break;
        }
      }
    })
  }

  init() {
    this.update();
    window.addEventListener('resize', this.update.bind(this));
    this.gallery.addEventListener('scroll', this.update.bind(this));
  }

  update() {
    const items = this.gallery.querySelectorAll('[data-index]');
    const scrollLeft = this.gallery.scrollLeft;
    const scrollWidth = this.gallery.scrollWidth;
    const clientWidth = this.gallery.clientWidth;
    const blockWidth = items[0]?.offsetWidth ?? 0;
    const hasScroll = scrollWidth > clientWidth;

    
    this.maxLength = items.length - (Math.floor(clientWidth / blockWidth) - 1);
    this.currentSlide = Math.round(scrollLeft / blockWidth) + 1;    

    if (this.counter) {
      this.counter.innerText = `${this.currentSlide} / ${items.length}`;
    }

    this.prevButton?.toggleAttribute("disabled", this.currentSlide == 1);
    this.nextButton?.toggleAttribute("disabled", this.currentSlide == this.maxLength);

    this.prevButton?.classList.toggle("hidden", !hasScroll);
    this.nextButton?.classList.toggle("hidden", !hasScroll);

    if (this.navGallery) {
      const navGallerySlides = this.navGallery.querySelectorAll("[data-index]");

      navGallerySlides.forEach((navGallerySlide, i) => {
        const index = ++i;        
        navGallerySlide.classList.toggle("active", index === this.currentSlide);
      });
    }
  }

  scrollToSlide(index) {
    this.gallery.scrollTo({
      left: this.gallery.querySelector(`[data-index="${index}"]`).offsetLeft,
      behavior: 'smooth'
    });
  }
}

if (document.querySelector("product-lightbox")) {
  customElements.define("product-lightbox", ProductLightbox);
}